import {Component, OnInit} from '@angular/core';
import {AirportService} from './airport.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'airport-prototype';
  queues: any[];
  constructor(private airportService: AirportService) {
  }

  ngOnInit(): void {
    this.airportService.getWaitingTimes().subscribe(a => this.queues = a.current);
  }

}
